import { NgModule, LOCALE_ID } from '@angular/core';
import { CommonModule } from '@angular/common';

import { PageModule } from './pages/page.module';

import { DatasetService } from './services/dataset.service';
import { CartService } from './services/cart.service';
import { TourService } from './services/tour.service';
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { RequestsInterceptor } from './services/requests.interceptor';
import { DatasetActionContainerService } from './services/datasetACS';
import { RecordService } from './services/record.service';
import { AppService } from './services/app.service';

@NgModule({
	imports: [
		PageModule,
		CommonModule
	],
	exports: [
		PageModule,
		CommonModule
	],
	providers: [
		AppService,
		DatasetService,
		RecordService,
		DatasetActionContainerService,
		TourService,
		CartService,
		{
			provide: HTTP_INTERCEPTORS,
			useClass: RequestsInterceptor,
			multi: true,
		}
	],
})
export class MainModule{}
